import { Spacing } from '@doordash/design-language'
import styled from 'styled-components'

type WrapperProps = {
  isFullScreen: boolean
}

export const Wrapper = styled.div`
  height: ${(props: WrapperProps) =>
    !props.isFullScreen && `calc(100vh - 60px)`};

  .react-swipe-container {
    height: ${(props: WrapperProps) => (props.isFullScreen ? `100%` : `90%`)};

    > div {
      height: 100%;
    }
  }
`

export const Slide = styled.div`
  height: 100%;
`

export const SlideWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  align-items: center;
  height: 100%;
  padding: ${Spacing.Small}px;
`

export const Bottom = styled.div`
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  padding: ${Spacing.Large}px;
`

export const WaitWrapper = styled.div`
  display: flex;
  flex-direction: row;
  padding: ${Spacing.XxSmall}px;
`
